import type { LocationResponse, RouteResponse, SosEventResponse } from "@somewear/api";
import type { SendSosMessageDto } from "@somewear/model";
import { createActionSet } from "@somewear/model";

export const trackingLocationActions = {
	shareLocation: createActionSet<GeolocationPosition, LocationResponse.AsObject[]>(
		"tracking/locations/create",
	),
	shareWaypoint: createActionSet<GeolocationPosition, RouteResponse.AsObject>(
		"tracking/waypoints/create",
	),

	startSosSession: createActionSet<SendSosMessageDto, SosEventResponse.AsObject>(
		"tracking/sos/start",
	),
	resolveSosSession: createActionSet<void, SosEventResponse.AsObject>("tracking/sos/stop"),
};
